import TohidGame from './TohidGame';

function App() {
  return <TohidGame />;
}

export default App;